module.exports = __webpack_public_path__ + "static/p3-8d4dbf2a8faffd5b6e4197905257479d.png";